import type { SceneTemplateVariation } from "./lomdaTypes";
import { DEFAULT_LOMDA_STYLE } from "./styleUtils";

export { DEFAULT_LOMDA_STYLE } from "./styleUtils";

/** Background color for a non-selected scene item in the sidebar. */
export const SIDEBAR_SCENE_ITEM_BG_UNSELECTED = "#E5EEFF" as const;

/** Background color for the selected scene item in the sidebar (deep indigo frame). */
export const SIDEBAR_SCENE_ITEM_BG_SELECTED = "#1A237E" as const;

export const DEFAULT_LOMDA_SCRIPT_SETTINGS = {
    language: "he",
    toneOfVoice: "professional",
} as const;

export const DEFAULT_LOMDA_TEMPLATE: SceneTemplateVariation = "A";

export const DEFAULT_LOMDA_METADATA = {
    numOfScenes: 0,
    language: DEFAULT_LOMDA_SCRIPT_SETTINGS.language,
    toneOfVoice: DEFAULT_LOMDA_SCRIPT_SETTINGS.toneOfVoice,
    style: DEFAULT_LOMDA_STYLE,
};

export const DEFAULT_LOMDA_CONTENT = {
    scenes: [],
};
